<form [formGroup]="parentForm">
    <div class="mt-4">
        <lib-address-information
            #addressInformation
            class="d-block"
            [addressForm]="parentForm.controls['addressForm']"
            [zipCodeConfig]="{ mask: '00000-0000', maxLength: 10 }"
            [countriesFilter]="['US']"
            [googleCountryRestriction]="['us']"
            [selectedCountry]="'US'"
        />
    </div>

    <mat-form-field id="business-name" appearance="outline" class="d-block pb-0 w-100 mt-2">
        <mat-label>Business Name</mat-label>
        <input id="business-name-input" matInput formControlName="businessName" placeholder="Business Name" />
        <mat-error>
            <app-invalid-field [field]="'businessName'" [messageList]="errorList" />
        </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100 mt-0">
        <mat-label>EIN (Employer Identification Number)</mat-label>
        <input id="ein" matInput formControlName="ein" placeholder="XX-XXXXXXX" mask="00-0000000" />
        <mat-error>
            <app-invalid-field [field]="'ein'" [messageList]="errorList" />
        </mat-error>
    </mat-form-field>

    <div class="text-end">
        <span id="w9-link" class="w9-link" (click)="openW9()">Need a W9 Form?</span>
    </div>

    <div class="mb-3">
        <lib-file-upload
            #w9FileUpload
            id="w9-upload"
            fieldName="w9"
            [whiteListFile]="filesWhiteList"
            (filesAdded)="filesAdded($event)"
            [loading]="uploading"
            [isDisabled]="false"
            [isRequired]="true"
            [title]="titleW9"
            [subtitle]="subtitleW9"
            [maxFilesAllowed]="1"
            [errorMessage]="'Maximum of 1 file allowed'"
        />
        <lib-file-remover #w9FileRemover class="mt-2" fieldName="w9" />
    </div>

    <div class="mb-5">
        <lib-file-upload
            #bankLetterFileUpload
            id="bankletter-upload"
            fieldName="bankLetter"
            [whiteListFile]="filesWhiteList"
            (filesAdded)="filesAdded($event)"
            [loading]="uploading"
            [isDisabled]="false"
            [isRequired]="false"
            [title]="titleBankLetter"
            [subtitle]="subtitleBankLetter"
            [maxFilesAllowed]="1"
            [errorMessage]="'Maximum of 1 file allowed'"
        />
        <lib-file-remover #bankLetterFileRemover class="mt-2" fieldName="bankLetter" />
    </div>

    <app-next-previous-buttons [previousText]="'BACK'" [disabled]="!parentForm.valid" />
</form>
